import { React, useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment';

import CalenderImagePath from '../../../Image/GrayCalenderIcon.png';
import CalenderRightArrowImagePath from '../../../Image/CalenderRightArrow.png';
import CalenderLeftArrowImagePath from '../../../Image/CalenderLeftArrow.png';
import CalenderLeftArrow2ImagePath from '../../../Image/CalenderLeftArrow2.png';
import CalenderRightArrow2ImagePath from '../../../Image/CalenderRightArrow2.png';

export default function AppliedDateSelectModal(props) {
  const { appliedDate, setAppliedDate, onClickExit } = props;

  const [today, setToday] = useState(moment());
  const [appliedDateList, setAppliedDateList] = useState([]);

  const appliedFirstWeek = today.clone().startOf('month').week();
  const appliedLastWeek = today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();

  // 달력에 표출할 날짜 정리 //
  useEffect(() => {
    let newAppliedDateList = [];

    for (let week = appliedFirstWeek; week <= appliedLastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().startOf('year').week(week).startOf('week').add(i, 'day');

        newAppliedDateList.push(days);
      }
    }

    setAppliedDateList(newAppliedDateList);
  }, [today, appliedFirstWeek, appliedLastWeek])

  function dateClick(value) {
    setAppliedDate(value);
    onClickExit();
  }

  return (
    <Background>
      <ModalView>
        <CalenderExitButtonWrapper>
          <CalenderExit onClick={onClickExit}>
            <CalenderExitStickWrapper>
              <CalenderExitStick width={16} height={2}/>
              <CalenderExitStick width={2} height={16}/>
            </CalenderExitStickWrapper>
          </CalenderExit>
        </CalenderExitButtonWrapper>
        <TopLevelWrapper>
          <CalenderWrapper>
            <CalenderView>
              <TitleWrapper>
                <Arrow img={CalenderLeftArrow2ImagePath} onClick={() => setToday(today.clone().subtract(1, 'year'))} style={{ margin: `0 -7px 0 0` }} />
                <Arrow img={CalenderLeftArrowImagePath} onClick={() => setToday(today.clone().subtract(1, 'month'))} />
                <Title>{today.format('YYYY년 MM월')}</Title>
                <Arrow img={CalenderRightArrowImagePath} onClick={() => setToday(today.clone().add(1, 'month'))} />
                <Arrow img={CalenderRightArrow2ImagePath} onClick={() => setToday(today.clone().add(1, 'year'))} style={{ margin: `0 0 0 -7px` }} />
              </TitleWrapper>
              <DateColumnWrapper>
                <DateColumn style={{ width: `25px`, marginRight: `36px` }}>SUN</DateColumn>
                <DateColumn style={{ width: `30px`, marginRight: `34px` }}>MON</DateColumn>
                <DateColumn style={{ width: `23px`, marginRight: `36px` }}>TUE</DateColumn>
                <DateColumn style={{ width: `28px`, marginRight: `35px` }}>WED</DateColumn>
                <DateColumn style={{ width: `25px`, marginRight: `42px` }}>THU</DateColumn>
                <DateColumn style={{ width: `18px`, marginRight: `40px` }}>FRI</DateColumn>
                <DateColumn style={{ width: `24px`, marginRight: `28px` }}>SAT</DateColumn>
              </DateColumnWrapper>
              <TotalDateWrapper>
                {
                  appliedDateList.map((data, index) => (
                    data.format('MM') === today.format('MM') ?
                      <DateWrapper key={index}>
                        <Date isClicked={data.format('YY.MM.DD') === appliedDate.format('YY.MM.DD')} onClick={() => dateClick(data)}>
                          {data.format('D')}
                        </Date>
                      </DateWrapper>
                      :
                      <WithoutHoverDate key={index}>
                        {data.format('D')}
                      </WithoutHoverDate>
                  ))
                }
              </TotalDateWrapper>
            </CalenderView>
          </CalenderWrapper>
        </TopLevelWrapper>
      </ModalView>
    </Background>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const Background = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 24px 0px;

  width: 500px;

  border-radius: 10px;
  background-color: #FFFFFF;
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  gap: 32px;
`;

const CalenderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const CalenderView = styled.div`
  display: flex;
  flex-direction: column;
  
  border-radius: 8px;
  background-color: #FFFFFF;
  
  transition: all 0.3s ease-in-out;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin: 0px 0px 0px 22px;
`;

const Arrow = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  
  background: url(${props => props.img}) no-repeat center center;

  :hover {
    cursor: pointer;
  }
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;

  :hover {
    cursor: default;
  }
`;

const DateColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 29px;
  margin-left: 28px;
  margin-bottom: 23px;
`;

const DateColumn = styled.p`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: Poppins-bold;
  font-size: 12px;

  color: #6DD49E;
  
  margin: 0 0 0 0;
`;

const TotalDateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 448px;
  margin-left: 8px;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  // margin: 0 0 8px 0;
  padding: 0 7px 0 7px;

  margin: ${props => props.isRight ? `0 0 8px 7px` : props.isLeft ? `0 7px 8px 0` : `0 0 8px 0`};
  padding: ${props => props.isRight ? `0 7px 0 0` : props.isLeft ? `0 0 0 7px` : `0 7px 0 7px`};

  border-radius: ${props => props.isRight ? `48px 0 0 48px` : props.isLeft ? `0 48px 48px 0` : `0 0 0 0`};
  background-color: ${props => props.isComprise ? `#ECECEC` : `#FFFFFF`};
`;

const Date = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  // background-color: ${props => props.isClicked ? `#6DD49E` : props.isComprise ? `#ECECEC` : `#FFFFFF`};
  background-color: ${props => props.isClicked ? `#6DD49E` : `#FFFFFF`};
  
  font-family: Poppins-Medium;
  font-size: 14px;

  color: ${props => props.isClicked ? `#FFFFFF` : `#595959`};

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    background-color: #6DD49E;
    color: #FFFFFF;

    font-fmaily: Poppins-Bold;
    font-size: 14px;
  }
`;

const WithoutHoverDate = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  margin: 0 7px 5px 7px;

  background-color: #FFFFFF;

  font-family: Poppins-Regular;
  font-size: 14px;

  color: #777777;

  :hover {
    cursor: default;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const CalenderExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 456px;
`;

const CalenderExit = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  :hover {
    cursor: pointer;
  }
`;

const CalenderExitStickWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  :hover {
    cursor: pointer;
  }
`;

const CalenderExitStick = styled.div`
  position: absolute;
  
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  
  border-radius: 4px;
  background-color: #CBCBCB;

  transform: rotate(45deg);
`;